import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { IdentityService, LicensingService } from 'identity';
import { NavigationService } from 'netview';
import { LicenseInfoDto } from 'UvExplorerServer.Dtos.TS/LicenseStats';
import { Subscription } from 'rxjs/Rx';
import { DateService } from 'base';
import { TopoMapConfigurationService } from 'configuration/services/topo-map-configuration.service';
import { ConfigurationService } from 'configuration';
import { UserSettingsService } from 'main/services/user-settings.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

    navClass: string = "nav-container-hidden";
    navHidden: boolean = false;
    gracePeriodMax = 14;
    notActivatedError = [{ severity: 'error', summary: 'Product Not Activated', detail: 'UVexplorer Server does not have a valid license and has been placed in read only mode.' }]
    gracePeriodError;
    private licenseInfoUpdatedSub: Subscription;

    constructor(private identityService: IdentityService,
        private navService: NavigationService, // Force NavigationService to be initialized
        private licensingService: LicensingService,
        private dateService: DateService,
        private configurationService: ConfigurationService,
        private topoMapConfigurationService: TopoMapConfigurationService,
        public themeService: UserSettingsService) {

        this.licenseInfoUpdatedSub = this.licensingService.onLicenseInfoUpdated.subscribe(licenseInfo => {
            //this.changeDetector.markForCheck();
        });
    }

    ngOnInit() {
        // This will be simplified when removing identity service
        this.identityService.onLogin.subscribe(
            data => {
                this.setActivationStatus();
            }
        )
        this.licensingService.onLicenseInfoUpdated.subscribe(x => {
            this.setGracePeriodMessage();
        })
    }

    ngOnDestroy() {
        if (this.licenseInfoUpdatedSub) {
            this.licenseInfoUpdatedSub.unsubscribe();
            this.licenseInfoUpdatedSub = undefined;
        }
    }

    public setActivationStatus() {
        this.licensingService.getLicenseInfo().subscribe(
            (licenseInfo: LicenseInfoDto) => {
                this.setGracePeriodMessage();
            },
            error => {
                console.error("There was an error getting license details");
            }
        );
    }

    private setGracePeriodMessage() {
        var expirationDate = this.dateService.formatDate(this.expiresOn);
        var details = `Your UVexplorer Server license expired on ${expirationDate}. You have a grace period of ${this.gracePeriodRemaining} days remaining before your product will stop updating with new network data.`
        this.gracePeriodError = [{ severity: 'warn', summary: 'Product Activation Grace Period', detail: details }]
    }

    get showLogin(): boolean {
        return (this.identityService.isReady && !this.identityService.isLoggedIn);
    }

    get showContent(): boolean {
        return (this.identityService.isReady && this.identityService.isLoggedIn);
    }

    get showNotActivatedError(): boolean {
        if (this.licensingService.hasLicenseInfo) {
            return !this.licensingService.isLicenseValid;
        }
        else {
            return false;
        }
    }

    get showGracePeriodError(): boolean {
        if (this.licensingService.hasLicenseInfo) {
            return this.licensingService.isInGracePeriod;
        }
        else {
            return false;
        }
    }

    get expiresOn() {
        return this.licensingService.licenseExpires;
    }

    get gracePeriodRemaining() {
        return this.licensingService.gracePeriodRemaining;
    }

    public hideShowNav() {
        this.navHidden = !this.navHidden;
        var navBlock = document.getElementById("nav-block");
        var closedMinNav = document.getElementById("closed-nav-min");
        if (navBlock.style.display === "none") {
            navBlock.style.display = "block";
            closedMinNav.style.display = "none";
        } else {
            navBlock.style.display = "none";
            closedMinNav.style.display = "block";
        }
    }
}

